import { render, staticRenderFns } from "./FormInnovations.vue?vue&type=template&id=b3db63f4&"
import script from "./FormInnovations.vue?vue&type=script&lang=js&"
export * from "./FormInnovations.vue?vue&type=script&lang=js&"
import style0 from "./FormInnovations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports